import { render, staticRenderFns } from "./cms-block.vue?vue&type=template&id=fa8b896c"
import script from "./cms-block.vue?vue&type=script&lang=js"
export * from "./cms-block.vue?vue&type=script&lang=js"
import style0 from "./cms-block.vue?vue&type=style&index=0&id=fa8b896c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports